<template>
  <label id="date-picker" :class="['full-width', labelClass]" @click="noOp">
    <div v-if="!noLabel && (inputLabel || hintLabel)">
      <span v-if="inputLabel" class="date-picker-label">{{ inputLabel }}</span>
      <span v-if="hintLabel" style="color: #626262"
        ><em>{{ hintLabel }}</em></span
      >
    </div>
    <slot name="date"></slot>
    <date-picker
      v-model:value="date"
      :format="format"
      value-type="format"
      type="time"
      :placeholder="placeholderLabel"
      class="full-width"
      v-bind="$attrs"
      :input-class="`form-control date-picker-input full-width ${
        (findByName(validationError, name) || fieldError) && 'is-invalid'
      }`"
      :disabled="disabled"
      @change="checkClearingData"
      @blur="$emit('blur')"
    ></date-picker>
    <div
      v-if="findByName(validationError, name) || fieldError"
      class="error-container"
    >
      <span class="text-danger error-text">{{
        findByName(validationError, name) || fieldError
      }}</span>
    </div>
  </label>
</template>

<script>
import moment from "moment-timezone";
import DatePicker from "vue-datepicker-next";
import { findByName } from "@/lib/vuelidate_helpers";

import { customDateFormatWithTimezone } from "@/mixins";
import useVuelidate from "@vuelidate/core";
import "vue-datepicker-next/index.css";
window.moment = moment;

export default {
  components: {
    "date-picker": DatePicker
  },
  props: {
    format: {
      type: String,
      default: "h:mm a"
    },
    labelClass: {
      type: String,
      default: ""
    },
    name: {
      type: String,
      default: ""
    },
    label: {
      type: String,
      default: ""
    },
    noLabel: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: ""
    },
    hintLabel: {
      type: String,
      default: ""
    },
    modelValue: {
      type: [String, Date, Array],
      default: null
    },
    valueType: {
      type: String,
      default: "format"
    },
    validationErrors: {
      type: Object,
      default() {
        return {
          first: () => {}
        };
      }
    },
    fieldError: {
      type: String,
      default: ""
    },
    disabled: {
      type: Boolean,
      default: false
    },
    inputFormat: {
      type: String,
      default: ""
    }
  },
  emits: ["update:modelValue", "blur", "clear-date"],
  setup() {
    return {
      v$: useVuelidate()
    };
  },
  computed: {
    date: {
      get() {
        return customDateFormatWithTimezone(
          this.modelValue,
          this.format,
          window.currentTenant.timezone,
          this.inputFormat
        );
      },
      set(val) {
        this.$emit("update:modelValue", val);
      }
    },
    inputLabel() {
      return this.label || this.name || this.placeholder;
    },
    placeholderLabel() {
      return this.placeholder || this.name;
    }
  },
  methods: {
    findByName,
    noOp(e) {
      // Prevent label click from opening calendar
      // Calendar should only open on input click
      e.preventDefault();
    },
    checkClearingData(date) {
      if (!date || (!date[0] && !date[1])) {
        this.$emit("clear-date");
      }
    }
  }
};
</script>

<style lang="scss">
.date-range-picker.mx-datepicker-main {
  .mx-datepicker-content {
    display: flex;
    .mx-datepicker-body {
      order: 2;
    }
    .mx-datepicker-footer {
      order: 1;
      border-right: 1px solid #e8e8e8;
      .shortcuts {
        flex-direction: column;
      }
    }
  }
}
.mx-time-column .mx-time-list::after {
  height: 5px !important;
}
.mx-time-content {
  height: 110px;
}
.mx-time {
  width: 160px;
}
.mx-time-item {
  color: var(--sera-color-text-body) !important;
  &.active {
    color: var(--sera-color-text-links) !important;
  }
}
.date-picker-label {
  color: var(--font-color);
  margin-left: 2px;
  margin-bottom: 3px;
  display: inline-block;
  font-weight: bold;
  min-height: 15px;
}
.date-picker-input {
  padding-right: 20px;
}

.error-container {
  height: 18px;
}
</style>
